import { NavigationGuardNext, Route } from 'vue-router';
import ServerBuilder from '../dashboard/server-create/ServerBuilder.vue';
import CreateAccountView from './CreateAccount.vue';
import CreateAccountAsInvitedView from './CreateAccountAsInvited.vue';
import ForgotPasswordView from './ForgotPassword.vue';
import MagicLinkView from './MagicLink.vue';
import RequestUnlockView from './RequestUnlock.vue';
import SignInView from './SignIn.vue';

export default [
  // ...ServerCreateRoutes,
  {
    path: '/',
    name: 'home',
    redirect: '/account/create',
    meta: {
      prelogin: true,
    },
  },
  {
    path: '/account/create',
    name: 'createAccount',
    component: CreateAccountView,
    meta: {
      prelogin: true,
      welcome: true,
    },
  },
  {
    path: '/account/invited',
    name: 'createAccountAsInvited',
    component: CreateAccountAsInvitedView,
    meta: {
      prelogin: true,
      welcome: true,
    },
  },
  {
    path: '/account/signin',
    name: 'signin',
    component: SignInView,
    meta: {
      prelogin: true,
      welcome: true,
    },
  },
  {
    path: '/account/magic-link',
    name: 'magicLink',
    component: MagicLinkView,
    meta: {
      prelogin: true,
      welcome: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPasswordView,
    meta: {
      prelogin: true,
      welcome: true,
    },
  },
  {
    path: '/request-unlock',
    name: 'RequestUnlock',
    component: RequestUnlockView,
    meta: {
      prelogin: true,
      welcome: true,
    },
  },
  {
    // The public price calculator is a static, crawlable page generated at build time
    // (packages/scripts/generatePricingPage.js). Keep the old hash URL working.
    path: '/pricing',
    name: 'PriceCalculator',
    beforeEnter: () => {
      window.location.replace('/pricing.html');
    },
  },
  {
    path: '/get-started',
    name: 'preloginServerBuilder',
    component: ServerBuilder,
    redirect: '/get-started/choose-plan',
    meta: {
      prelogin: true,
      welcome: false,
      hideFooter: true,
      title: 'Create a Countly Flex account | Countly Flex',
    },
    children: [
      {
        path: 'choose-plan',
        name: 'preloginChoosePlan',
        meta: {
          hideNavbar: true,
          prelogin: true,
          hideFooter: true,
        },
        component: () => import('../dashboard/server-create/ChoosePlan.vue'),
      },
      {
        path: 'choose-region',
        name: 'preloginChooseRegion',
        meta: {
          hideNavbar: true,
          prelogin: true,
          hideFooter: true,
        },
        component: () => import('../dashboard/server-create/ChooseRegion.vue'),
      },
      {
        path: 'core-features',
        name: 'preloginCoreFeatures',
        meta: {
          hideNavbar: true,
          prelogin: true,
          hideFooter: true,
        },
        component: () => import('../dashboard/server-create/CoreFeatures.vue'),
      },
      {
        path: 'choose-add-ons',
        name: 'preloginChooseAddOns',
        meta: {
          hideNavbar: true,
          prelogin: true,
          hideFooter: true,
        },
        component: () => import('../dashboard/server-create/ChooseAddOns.vue'),
      },
      {
        path: 'choose-extras',
        name: 'preloginChooseExtras',
        meta: {
          hideNavbar: true,
          prelogin: true,
          hideFooter: true,
        },
        component: () => import('../dashboard/server-create/ChooseExtras.vue'),
      },
      {
        path: 'complete-setup',
        name: 'preloginRegister',
        meta: {
          hideNavbar: true,
          prelogin: true,
          hideFooter: true,
        },
        component: () => import('./CreateAccountWithServer.vue'),
      },
    ],
  },
  // retired free tools — anyone landing on the old URLs is sent to countly.com
  {
    path: '/tools/countly-dashboard-preview',
    meta: { prelogin: true },
    beforeEnter: (_to: Route, _from: Route, next: NavigationGuardNext) => {
      window.location.replace('https://countly.com');
      next(false);
    },
  },
  {
    path: '/tools/free-app-profile-review',
    meta: { prelogin: true },
    beforeEnter: (_to: Route, _from: Route, next: NavigationGuardNext) => {
      window.location.replace('https://countly.com');
      next(false);
    },
  },
];
